import { render, staticRenderFns } from "./OrderListCargo.vue?vue&type=template&id=35bae478&"
import script from "./OrderListCargo.vue?vue&type=script&lang=js&"
export * from "./OrderListCargo.vue?vue&type=script&lang=js&"
import style0 from "./OrderListCargo.vue?vue&type=style&index=0&id=35bae478&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports